<div class="json-editor-container">
  <textarea class="json-textarea" [(ngModel)]="jsonText" (input)="onInput($event)" [disabled]="disabled"
    [placeholder]="placeholder"></textarea>
  <span *ngIf="isInvalidJson" class="text-red-500 text-xs">Invalid JSON format</span>
</div>
